import { render, staticRenderFns } from "./cardCouponList.vue?vue&type=template&id=4aea9a2e&scoped=true"
import script from "./cardCouponList.vue?vue&type=script&lang=js"
export * from "./cardCouponList.vue?vue&type=script&lang=js"
import style0 from "./cardCouponList.vue?vue&type=style&index=0&id=4aea9a2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aea9a2e",
  null
  
)

export default component.exports